import { render, staticRenderFns } from "./ExhibitorCard.vue?vue&type=template&id=87a4e4a0&scoped=true"
import script from "./ExhibitorCard.vue?vue&type=script&lang=js"
export * from "./ExhibitorCard.vue?vue&type=script&lang=js"
import style0 from "./ExhibitorCard.vue?vue&type=style&index=0&id=87a4e4a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a4e4a0",
  null
  
)

export default component.exports